var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterColumn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Column",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6182",
    "data-name": "Rectangle 6182",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_18",
    "data-name": "Subtraction 18",
    d: "M14.007,18.793a1.089,1.089,0,0,1-1.085-1.09V1.09a1.086,1.086,0,1,1,2.172,0V17.7A1.089,1.089,0,0,1,14.007,18.793Zm-6.461,0A1.089,1.089,0,0,1,6.46,17.7V1.09a1.086,1.086,0,1,1,2.172,0V17.7A1.089,1.089,0,0,1,7.546,18.793Zm-6.459,0A1.089,1.089,0,0,1,0,17.7V1.09a1.085,1.085,0,1,1,2.171,0V17.7A1.088,1.088,0,0,1,1.086,18.793Z",
    transform: "translate(8.698 6.603)",
    fill: "#6d809f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterColumn);
export default __webpack_public_path__ + "static/media/filter_column.097b1d510029067c7704998afa2b3fd8.svg";
export { ForwardRef as ReactComponent };